export function base64ToImageUrl(base64String) {
  if (!base64String) return

  const mime = base64String.split(',')[0].split(':')[1].split(';')[0];

  const binary = atob(base64String.split(',')[1]);

  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  const blob = new Blob([new Uint8Array(array)], { type: mime });

  const url = URL.createObjectURL(blob);

  return url;
}

// cut extensions
export function removeFileExtensions(filename) {
  const extensionsToRemove = /\.(doc|docx|pdf)$/;

  const cleanedFilename = filename.replace(extensionsToRemove, '');

  return cleanedFilename;
}

// 
export const getYearFromDateString = (dateString) => {
  const parts = dateString.split('.');
  if (parts.length === 3) {
    return parseInt(parts[2], 10);
  }
  return null;
};

// get nested pages from headerItems using pathname
export const getNestedPages = (data, pathname) => {
  const matchingHeaderItem = data?.find(item =>
    item?.dropdown?.some(dropdownItem => pathname?.includes(dropdownItem?.path))
  );

  return matchingHeaderItem?.dropdown;
};

// youtube embeds video
export const getYouTubeEmbedUrl = (url) => {
  let embedUrl = '';

  if (url.includes('youtube.com')) {
    const urlParams = new URLSearchParams(new URL(url).search);
    const videoId = urlParams.get('v');
    if (videoId) {
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    }
  } else if (url.includes('youtu.be')) {
    const videoId = url.split('/').pop();
    if (videoId) {
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    }
  }

  return embedUrl;
}

// clear text from html 
export const htmlToText = (htmlString) => {
  if (!htmlString) return "";
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
}